// extracted by mini-css-extract-plugin
export var bodySections = "_5j-8";
export var gray = "_5j-7";
export var green = "_5j-4";
export var iconContainer = "_5j-9";
export var iconWidgetContainer = "_5j-1";
export var phoneIcon = "_5j-2";
export var red = "_5j-5";
export var statusDot = "_5j-3";
export var widgetContainer = "_5j-0";
export var yellow = "_5j-6";